export default "__VITE_ASSET__D6hEP_js__"